import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";
import { MaskReveal } from "@/components/site/motion";

export default function PageHeader({ eyebrow, title, subtitle, crumb }) {
  return (
    <section className="relative pt-[132px] md:pt-[160px] pb-14 md:pb-20 bg-steel-900 overflow-hidden" data-testid="page-header">
      <div className="absolute inset-0 grill-lines opacity-40 pointer-events-none" />
      <div className="absolute -right-24 -top-24 w-96 h-96 rounded-full bg-gold-400/10 blur-3xl pointer-events-none" />
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 relative">
        <motion.nav
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.1 }}
          aria-label="Breadcrumb"
          className="flex items-center gap-2 text-xs font-label uppercase tracking-widest text-steel-400 mb-6"
        >
          <Link to="/" className="hover:text-gold-400 transition-colors">Home</Link>
          <ChevronRight size={13} aria-hidden="true" />
          <span className="text-gold-400">{crumb || title}</span>
        </motion.nav>
        {eyebrow && (
          <motion.p
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.15 }}
            className="font-label text-xs tracking-[0.3em] uppercase text-gold-400 mb-4 flex items-center gap-3"
          >
            <span className="h-px w-10 bg-gold-400" /> {eyebrow}
          </motion.p>
        )}
        <h1 aria-label={Array.isArray(title) ? title.join(" ") : title} className="font-display font-black text-white tracking-tighter leading-[0.95] text-4xl md:text-6xl lg:text-7xl">
          <MaskReveal lines={Array.isArray(title) ? title : [title]} delay={0.1} />
        </h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5 }}
            className="mt-6 text-base md:text-lg text-steel-300 max-w-2xl leading-relaxed"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
